import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Switch } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";

const { Option } = Select;

interface UserFormModalProps {
  open: boolean;
  editingUser?: any;
  userTypes: any[];
  onCancel: () => void;
  onSave: (values: any) => void;
}

export const UserFormModal: React.FC<UserFormModalProps> = ({
  open,
  editingUser,
  userTypes,
  onCancel,
  onSave,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editingUser) {
      form.setFieldsValue({
        username: editingUser.username,
        password: editingUser.password,
        user_type_id: editingUser.user_type_id,
        is_active: editingUser.is_active === "1",
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ is_active: true });
    }
  }, [editingUser, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onSave(values);
  };

  return (
    <Modal
      title={editingUser ? "Edit User" : "Add New User"}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form form={form} layout="vertical" className="mt-4">
        <Form.Item
          name="username"
          label="Username"
          rules={[{ required: true, message: "Please input username!" }]}
        >
          <Input prefix={<UserOutlined />} placeholder="Username" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: "Please input password!" }]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder="Password" />
        </Form.Item>

        <Form.Item
          name="user_type_id"
          label="User Type"
          rules={[{ required: true, message: "Please select user type!" }]}
        >
          <Select placeholder="Select User Type">
            {userTypes?.map((type) => (
              <Option key={type.id} value={type.id}>
                {type.type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="is_active" label="Status" valuePropName="checked">
          <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
